import { render, staticRenderFns } from "./StoreRankDataGrid.vue?vue&type=template&id=0bc4a35f&scoped=true"
import script from "./StoreRankDataGrid.vue?vue&type=script&lang=js"
export * from "./StoreRankDataGrid.vue?vue&type=script&lang=js"
import style0 from "./StoreRankDataGrid.vue?vue&type=style&index=0&id=0bc4a35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4a35f",
  null
  
)

export default component.exports